namespace Attributes {
  type DataType = 'string'
    | 'object'
    | 'array'
    | 'integer'
    | 'number'
    | 'boolean'
    | 'bool';

  type Properties = {
    [key: string]: DataType
  };

  type Format = 'long' | 'url' | 'email' | 'date' | 'price-rating';

  interface Schema {
    type: DataType;
    items?: Schema;
    properties?: Properties;
    format?: Format;
  }

  export type Value = string | number | boolean | null;

  export interface Option {
    id?: string;
    label?: string;
    name?: string;
    value?: Value | Value[];
  }

  export interface Definition {
    component?: string;
    dependents?: any[];
    depends_on?: boolean;
    description?: string;
    editing: boolean;
    featureFlag?: string;
    // Key into the Atlas attribute group registry, naming the section this belongs in
    group?: string;
    id: string;
    label: string;
    labelId: string;
    name: string;
    num: number;
    onChange: (value: Value | Value[]) => void;
    options?: Option[];
    schema: Schema;
    show: boolean;
    // Unit suffix for numeric inputs, eg. 'ft', 'nights'
    unit?: string;
    value?: Value | Value[];
    values?: Value[];
    hideNull?: boolean;
    active?: boolean;
    hideLabel?: boolean;
  }

  export type Definitions = Definition[]
}
